import { Slot } from "@radix-ui/react-slot";
import type { ReactElement } from "react";

/** Shared session shell: the resolved mode supplies surfaces, the gym supplies the accent. */
export function ScheduleSessionSurface({ children }: { children: ReactElement }) {
  return <Slot className="schedule-session-surface">{children}</Slot>;
}